<template>
  <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.0376 3.53566L0.723891 14.8494L0.478981 17.5434C0.422441 18.1653 0.943474 18.6863 1.56541 18.6298L4.25943 18.3849L15.5731 7.07119L12.0376 3.53566Z" :fill="fill" />
    <path d="M16.2802 6.36409L18.4016 4.24275C18.7921 3.85223 18.7921 3.21906 18.4016 2.82854L16.2802 0.707216C15.8897 0.316692 15.2566 0.316692 14.866 0.707216L12.7447 2.82855L16.2802 6.36409Z" :fill="fill" />
  </svg>
</template>

<script>
export default {
  name: 'IconPencil',
  props: {
    fill: {
      type: String,
      default: '#ffffff'
    }
  }
}
</script>
